import { useEffect } from 'react'
import useHover from '../useHover'

const useDisableBrowserSwipe = () => {
  const [hoverRef, isHovered] = useHover<HTMLDivElement>()

  useEffect(() => {
    if (!isHovered) return

    const html = document.querySelector('html')
    const body = document.querySelector('body')

    ;[html, body].forEach((el) => el?.classList.add('no-swipe'))

    return () => {
      ;[html, body].forEach((el) => el?.classList.remove('no-swipe'))
    }
  }, [isHovered])

  return [hoverRef, isHovered] as const
}

export default useDisableBrowserSwipe
